import { render, staticRenderFns } from "./PicZoom.vue?vue&type=template&id=77973caa&scoped=true&"
import script from "./PicZoom.vue?vue&type=script&lang=js&"
export * from "./PicZoom.vue?vue&type=script&lang=js&"
import style0 from "./PicZoom.vue?vue&type=style&index=0&id=77973caa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77973caa",
  null
  
)

export default component.exports